// eslint-disable-next-line no-restricted-imports
import {
  Link,
  useNavigate,
  useParams as useParamsRRD,
  useBlocker as useBlockerRRD,
  useRouteError,
  isRouteErrorResponse,
} from 'react-router'
import { useCallback } from 'react'

export const PlainLink = Link

export function useNavigateWithSearch() {
  const navigate = useNavigate()
  return useCallback(
    (params: { pathname: string; search: string }) => {
      navigate(params)
    },
    [navigate],
  )
}

export function useReplace() {
  const navigate = useNavigate()
  return useCallback(
    (path: string) => {
      navigate(path, { replace: true })
    },
    [navigate],
  )
}

export function useNavigateTo() {
  const navigate = useNavigate()
  return useCallback(
    (path: string) => {
      navigate(path)
    },
    [navigate],
  )
}

export function useGoBack() {
  const navigate = useNavigate()
  return useCallback(() => {
    navigate(-1)
  }, [navigate])
}

export function useParams(): Record<string, string | undefined> {
  return useParamsRRD() as Record<string, string | undefined>
}

export const useBlocker = useBlockerRRD

export { useRouteError, isRouteErrorResponse }
